// Comparelist - Globals
let cpl_wrapper                 = the_bod.find( '.cpl_wrapper' ); // The main comparelist wrapper - used for the size initializer
let cpl_actions                     = cpl_wrapper.find( '.cpl_actions' ); // The comparelist actions
let cpl_info                        = cpl_wrapper.find( '.cpl_info' ); // The comparelist info bar
let cpl_container                   = cpl_wrapper.find( '.cpl_container' ); // The scrollable comparelist container
let cpl_tab                         = cpl_container.find( '.cpl_table' ); // The actual comparelist table
let cpl_head                        = cpl_tab.find( '.cpl_head' ); // The comparelist table head
let cpl_body                        = cpl_tab.find( '.cpl_body' ); // The comparelist table body
let cpl_columns             = 5 // Default amount of columns for the table initializer logic
let cpl_sorting             = false; // Flag to indicate if sorting is allowed
let cpl_dragged             = false; // Flag to indicate if dragging is in progress
let cpl_scroll_pos_x; // Variable to store the initial scroll position
let cpl_highlighting        = false; // Flag to highlight item column data (on hover)
// Prep. comparelist sort order array
let cpl_sort_arr               = [];

the_doc.ready( function() {
    if( CVS_COMPARE_LIST_ACTIVE === 'true'){
        if ( cpl_wrapper.length && typeof cpl_wrapper !== 'undefined' ) {
            jQuery( do_cpl() ).promise().done( function() {
                cpl_th();
            });
        } else { // do a count
            do_cpl();
        }
    }
});

// Triggers stuff when EVERYTHING has finished loading ...
the_win.on( 'load', function() {
    // First check for the comparelist - is it even there?
    if ( cpl_wrapper.length && typeof cpl_wrapper !== 'undefined' ) {
        // Trigger size initializer
        cpl_size();
    }
});

// When the viewport is being resized
the_win.on( 'resize', function() {
    // console.log( 'Viewport size has changed' );
    // First check for the comparelist - is it even there?
    if ( cpl_wrapper.length && typeof cpl_wrapper !== 'undefined' ) {
        // Trigger comparelist size initializer
        debounce( cpl_size, 10 );
    }
});

// ----------------------------

// When the window is being scrolled
the_win.on( 'scroll', function() {
    // First check for the comparelist - is it even there?
    if ( cpl_wrapper.length && typeof cpl_wrapper !== 'undefined' ) {
        // Trigger sticked
        wait( 150 ).then( function() {
            cpl_sticked();
        });
    }
});

// ----------------------------

// Attach scroll event handler to all target tables - x-axis only
cpl_container.on( 'scroll', function() {
    let _this = jQuery( this );
    // Get the current horizontal scroll position of the scroll initiator table
    let scrollLeft = _this.scrollLeft();
    // Set the scroll position of all other target tables
    cpl_container.not( _this ).scrollLeft( scrollLeft );
});

// ----------------------------

// Comparelist buttons
// TODO: Key navigation doesn't work!!
cpl_wrapper.on( 'click', '.js_cpl_button', function( e ) {
    let _this       = jQuery( this );
    let this_arg    = _this.attr( 'data-arg' );
    cpl_button( _this, this_arg );
});

// Attach event listeners for dragging or touching within the comparelist
// Highlight comparelist item column data
// cpl_container.on({
the_bod.find( '.cpl_container' ).on({
    mouseover: function( e ) {
        cpl_get_heading( jQuery( this ), true );
        cpl_highlight_column( jQuery( this ), true );
    },
    mousedown: function( e ) {
        cpl_drag_start( e );
    },
    touchstart: function( e ) {
        cpl_drag_start( e );
    },
    mousemove: function( e ) {
        cpl_drag_move( e );
    },
    touchmove: function( e ) {
        cpl_drag_move( e );
    },
    mouseup: function( e ) {
        cpl_drag_end( e );
    },
    touchend: function( e ) {
        cpl_drag_end( e );
    },
    mouseleave: function( e ) {
        cpl_get_heading( jQuery( this ), false );
        cpl_highlight_column( jQuery( this ), false );
    },
    click: function( e ) {
        cpl_get_heading( jQuery( this ), true, 'click' );
        cpl_highlight_column( jQuery( this ), true );
    }
}, 'td' );

// Comparelist keyboard navigation (left / right)
// NOTE: The "keydown" event conditions might prevent normal behaviour
// the_htm.on({
//     keypress: function( e ) {
//         cpl_key( e, jQuery( this ) );
//     },
//     keydown: function( e ) {
//         cpl_key( e, jQuery( this ) );
//     }
// }, the_doc );

// ----------------------------

// Trigger the sticked comparelist header when scrolled past the "trigger part"
function cpl_sticked() {
    // let cpl_sticked_target	= jQuery( '.cpl_container.sticked' );
    let cpl_sticked_target	= cpl_wrapper.find( '.cpl_container.sticked' );
    let cpl_sticked_trigger	= jQuery( '.cpl_container:not(.cpl_container.sticked) .cpl_body > tr:first-of-type' );
    // let scroll_margin       = cpl_sticked_trigger.height() / 2;
    let scroll_margin       = 100;
    let viewport_top        = the_win.scrollTop();
    let elem_top            = cpl_sticked_trigger.offset().top;
    // Show / hide scroll header
    if (( elem_top + scroll_margin ) <= viewport_top ) {
        // Add active class
        cpl_sticked_target.addClass( 'active' );
    } else {
        // Remove active class
        cpl_sticked_target.removeClass( 'active' );
    }
    // Fix th height for stubborn -webkit browsers
    cpl_th();
}

// ----------------------------

// Forced CSS after re-rendering columns based on new viewport dimensions
function cpl_css_minmax( elem, size ) {
    elem.css({
        'min-width' : size,
        'width'     : size,
        'max-width' : size
    });
}

// Set comparelist th height
// NOTE: This is a necessary hack due to the fact that some webkit web browsers move sticky elements out of the viewport
function cpl_th() {
    // Add comparelist th fix for specific web browsers
    if (
        webbrowser.indexOf( 'chrome' ) !== -1 ||
        webbrowser.indexOf( 'edge' ) !== -1 ||
        webbrowser.indexOf( 'safari' ) !== -1 ||
        webbrowser.indexOf( 'webkit' ) !== -1 )
    {
        // let table_tr = jQuery( '.cpl_container tr' );
        let table_tr = cpl_wrapper.find( '.cpl_container tr' );
        // Fix ths
        table_tr.each( function () {
            let _this       = jQuery( this );
            // let tr_height   = _this.outerHeight();
            let tr_height   = _this.height();
            let this_th     = _this.find( 'th' );
            // Debug ...
            // console.log( 'tr_height: ' + tr_height );
            // Add class
            _this.addClass( 'browser_fix' );
            // Set corrected th height
            this_th.css( 'height', tr_height );
        });
    }
}

// Size initializer
function cpl_size() {
    // Remove any old animation queues
    cpl_container.finish();
    // No smooth scrolling on touch devices (wrecks drag correction logic!)
    if ( the_htm.hasClass( 'is_touch' ) ) {
        the_htm.css( 'scroll-behavior', 'auto !important' ); // Seems to be buggy - oh well ...
    }
    // "Reset" comparelist wrapper elements width to 100% before rounding its new size
    cpl_css_minmax( cpl_actions, '100%' );
    cpl_css_minmax( cpl_info, '100%' );
    cpl_css_minmax( cpl_container, '100%' );
    // Re-calc to rounded number, preventing scroll logic to be wrecked
    // let current_width       = cpl_container.width();
    let current_width       = cpl_wrapper.width(); // Getting the max available width derived from the parent wrapper (prevents miscalculations)!
    // New rounded width for the comparelist wrapper
    let new_rounded_width   = Math.round( current_width / cpl_columns ) * cpl_columns;
    // Set new comparelist wrapper elements width
    cpl_css_minmax( cpl_actions, new_rounded_width );
    cpl_css_minmax( cpl_info, new_rounded_width );
    cpl_css_minmax( cpl_container, new_rounded_width );
    // Initial amount of columns displayed (global)
    let total_columns   = cpl_columns;
    // Column width
    let column_width    = new_rounded_width / cpl_columns;
    // Target tr /th / td
    let trs             = cpl_tab.find( 'tr' );
    let ths             = cpl_tab.find( 'th' );
    let tds             = cpl_tab.find( 'td' );
    // Set new column width based on viewport size smaller than the default container width
    if ( new_rounded_width < 1300 ) {
        total_columns       = ( cpl_columns - 1 );
        new_rounded_width   = Math.round( current_width / total_columns ) * total_columns;
        column_width        = new_rounded_width / total_columns;
    }
    // When things get even smaller ...
    if ( new_rounded_width < 950 ) {
        total_columns       = ( cpl_columns - 2 );
        new_rounded_width   = Math.round( current_width / total_columns ) * total_columns;
        column_width        = new_rounded_width / total_columns;
    }
    // OMG! It's so small! ... Now we fall back to a true responsive solution
    if ( new_rounded_width < 750 ) {
        cpl_info.addClass( 'active' );
        ths.hide();
        trs.addClass('mobile');

        total_columns       = ( cpl_columns - 3 );
        new_rounded_width   = Math.round(current_width / total_columns) * total_columns;
        column_width        = new_rounded_width / total_columns;
    }
    // Smallest ...
    if ( new_rounded_width < 550 ) {
        total_columns       = ( cpl_columns - 4 );
        new_rounded_width   = Math.round(current_width / total_columns) * total_columns;
        column_width        = new_rounded_width / total_columns;
    }
    // Revert responsive ...
    if ( new_rounded_width >= 750 ) {
        cpl_info.removeClass( 'active' );
        // Show / set new th width
        // cpl_css_minmax( ths, column_width );
        ths.show();
        trs.removeClass( 'mobile' );
    }
    // Set new comparelist wrapper elements width
    wait( 100 ).then( function() {
        cpl_css_minmax( cpl_actions, new_rounded_width );
        cpl_css_minmax( cpl_info, new_rounded_width );
        cpl_css_minmax( cpl_container, new_rounded_width );
        // Set new td width now that we have the total width, the last value we need before finishing calculations
        cpl_css_minmax( tds, column_width );
        cpl_css_minmax( ths, column_width );
        // Debug ...
        // console.log( 'Rounded width: ' + new_rounded_width );
        // console.log( 'Column width' + column_width );
        // Correct scroll position after viewport change
    }).then( function() {
        // Fix th height for stubborn -webkit browsers
        cpl_th();
    }).then( function() {
        // Correct drag
        debounce( cpl_drag_correction, 100 );
    });
}

// Comparelist interaction (outer)
function cpl_button( elem, arg, event ) {
    // Remove any old animation queues
    cpl_container.finish();
    let cpl_wrapper       = the_bod.find( '.cpl_wrapper' )
    let button_diff         = cpl_wrapper.find( '.cpl_button.diff' );
    let button_diff_only    = cpl_wrapper.find( '.cpl_button.diff_only' );
    let button_highlight    = cpl_wrapper.find( '.cpl_button.highlight' );
    let table_width         = the_bod.find( '.cpl_table' ).innerWidth();
    let td_width            = the_bod.find( '.cpl_table' ).find( 'tr:first td:first' ).outerWidth();
    let max_scroll          = the_bod.find( '.cpl_container' ).scrollWidth - table_width;
    let animation_time      = 100;
    let animation_type      = 'swing';
    let scroll_pos;
    // First check if this button is disabled
    if ( elem.hasClass( 'disabled' )) {
        return false;
    }
    // Switch stuff ...
    switch( arg ) {
        case 'diff':
            if ( elem.hasClass( 'active' )) {
                elem.removeClass( 'active' );
                cpl_all();
            } else {
                elem.addClass( 'active' );
                cpl_diff();
            }
            break;
        case 'diff_only':
            // First undo any highlighting
            if ( button_diff.hasClass( 'active' )) {
                button_diff.removeClass( 'active' );
            }
            button_diff.addClass( 'disabled' );

            if ( elem.hasClass( 'active' )) {
                elem.removeClass( 'active' );
                button_diff.removeClass( 'disabled' );
                cpl_all();
            } else {
                elem.addClass( 'active' );
                cpl_diff( 1 );
            }
            break;
        case 'highlight':
            if ( elem.hasClass( 'active' )) {
                elem.removeClass( 'active' );
                cpl_highlight_toggle();
            } else {
                elem.addClass( 'active' );
                cpl_highlight_toggle( 1 );
            }
            break;
        case 'sort':
            // First undo any highlighting
            button_diff.removeClass( 'active' );
            button_diff.addClass( 'disabled' );
            button_diff_only.removeClass( 'active' );
            button_diff_only.addClass( 'disabled' );
            button_highlight.removeClass( 'active' );
            button_highlight.addClass( 'disabled' );
            cpl_all();
            cpl_highlight_toggle();
            // ...
            if ( elem.hasClass( 'active' )) {
                elem.removeClass( 'active' );
                button_diff.removeClass( 'disabled' );
                button_diff_only.removeClass( 'disabled' );
                button_highlight.removeClass( 'disabled' );
                cpl_column_sort( event, false );
            } else {
                elem.addClass( 'active' );
                cpl_column_sort( event, true );
            }
            break;
        case 'del':
            do_cpl( 'del' );
            break;
        case 'start':
            scroll_pos = 0;
            break;
        case 'left':
            scroll_pos = '-=' + td_width;
            break;
        case 'right':
            scroll_pos = '+=' + td_width;
            break;
        case 'end':
            scroll_pos = max_scroll;
            break;
    }

    // Debug ...
    // console.log( 'Tiggered: ' + arg + ' | Scroll pos: ' + scroll_pos );

    // If end of scroll is reached, exit - else, do some scrolling ...
    if (( arg === 'right' || arg === 'end' ) && cpl_container.scrollLeft() >= max_scroll ) {
        return false;
    } else {
        cpl_container.animate({
            scrollLeft: scroll_pos
        }, {
            easing: animation_type
        }, animation_time ).promise().done( function() {
            cpl_drag_correction();
        });
    }
}


// Comparelist interaction (inner)
the_doc.on( 'click', '.js_cpl', function( e ) {
    let _this       = jQuery( this );
    let this_arg    = _this.attr( 'data-arg' );
    let this_ref    = _this.attr( 'data-ref' );
    // Switch arguments
    switch ( this_arg ) {
        case 'add':
            do_cpl( 'add', this_ref );
            break;
        case 'remove':
            do_cpl( 'remove', this_ref );
            break;
    }
});

// Cpmparelist keboard interaction
// TODO: Key navigation doesn't work!!
function cpl_key( event ) {
    // Key event
    let key = 'which' in event ? event.which : event.keyCode;
    // First check for the comparelist - is it even there?
    if ( cpl_wrapper.length && typeof cpl_wrapper !== 'undefined' ) {
        // NOTE: The "keydown" event conditions might prevent normal behaviour
        if ( key === 37 || key === 38 || key === 39 || key === 40 ) {
            event.preventDefault();
        }
        // Left
        if ( key === 37 ) {
            cpl_button( '', 'left' );
            // Right
        } else if ( key === 39 ) {
            cpl_button( '', 'right' );
            // Start (up key)
        } else if ( key === 38 ) {
            cpl_button( '', 'start' );
            // End (down key)
        } else if ( key === 40 ) {
            cpl_button( '', 'end' );
        }
    }
}

// Scroll the comparelist table by drag / touch
// Function to handle the start of dragging or touching within the table
function cpl_drag_start( event ) {
    // Remove any old animation queues
    cpl_container.finish();
    // Make sure we are targeting the comparelist
    if ( cpl_sorting === false ) {
        if (( jQuery( event.target ).not( '.sort' ) || jQuery( event.target ).className !== 'sort' ) && jQuery( event.target ).closest( '.cpl_container' ).length ) {
            cpl_dragged         = true;
            cpl_scroll_pos_x    = event.pageX || event.originalEvent.touches[0].pageX;
            // Remove any current animation queues
            cpl_container.finish();
            cpl_tab.css( 'user-select', 'none' ); // Seems to render much faster than toggling CSS classes
        }
    }
}

// Function to handle dragging or touching move
function cpl_drag_move( event ) {
    if ( ! cpl_dragged ) return;
    // Some vars ...
    let current_scroll_x = event.pageX || event.originalEvent.touches[0].pageX;
    let scroll_distance  = current_scroll_x - cpl_scroll_pos_x;
    // Update scroll position as well as the scroll position global
    cpl_container.scrollLeft( cpl_container.scrollLeft() - scroll_distance );
    cpl_scroll_pos_x = current_scroll_x;
}

// Function to handle the end of dragging or touching
function cpl_drag_end( event ) {
    // Remove any old animation queues
    cpl_container.finish();
    cpl_dragged = false;
    // cpl_tab.removeClass( 'dragging' );
    cpl_tab.css( 'user-select', 'initial' ); // Seems to render much faster than toggling CSS classes
    // Trigger correction after dragging
    debounce( cpl_drag_correction, 100 );
}

// Correct table scroll position after releasing mouse
function cpl_drag_correction( event ) {
    // Debug ...
    // console.log( 'Scrolling table' );

    // Remove any old animation queues
    cpl_container.finish();
    let cpl_td_width        = cpl_tab.find( 'tr:first td:first' ).outerWidth();
    let cpl_td_width_half   = Math.abs( cpl_td_width / 2 );
    let scrolled_x          = cpl_container.scrollLeft();
    let scrolled_diff       = scrolled_x % cpl_td_width;
    // Animation settings
    let animation_time = 100;
    let animation_type = 'easeInSine';
    // Check for equal scroll state direction
    if ( scrolled_x % cpl_td_width !== 0 ) {
        if ( scrolled_diff < cpl_td_width_half ) {
            // console.log( 'Adjust scroll to left' );
            cpl_container.animate({ scrollLeft: '-=' + scrolled_diff }, animation_time, animation_type );
        } else if ( scrolled_diff >= cpl_td_width_half ) {
            // console.log( 'Adjust scroll to right' );
            let new_scroll = scrolled_diff - cpl_td_width;
            cpl_container.animate({ scrollLeft: '-=' + new_scroll }, animation_time, animation_type );
        }
    }
}

// Find diff - Add diff class
function cpl_diff( bool ) {
    // All rows, but not the first
    let table_tr = jQuery( '.cpl_body tr:not(:first-of-type):not(.image)' );
    // Remove any previous "has_diff" row class
    table_tr.removeClass( 'has_diff' );
    // Loop through each row
    table_tr.each( function() {
        // Get all the <td> elements in the current row
        let row_tds     = jQuery( this ).find( 'td' );
        // Loop through each td
        row_tds.each( function() {
            let curr_td     = jQuery( this );
            // Get the trimmed text content of the current <td> element
            let curr_text   = curr_td.text().trim();
            // Assume the current <td> element is different from all others
            let is_diff     = true;
            // Loop through each td again
            row_tds.each( function() {
                let this_td         = jQuery( this );
                let this_td_text    = this_td.text().trim();
                // The current <td> element is not different from at least one other <td> element
                if ( this_td_text === curr_text && ! this_td.is( curr_td )) {
                    is_diff = false;
                    // Exit loop ...
                    return false;
                }
            });
            // Found diff, add "diff" row class
            let this_diff_row   = curr_td.closest( 'tr' );
            if ( is_diff ) {
                let this_th     = this_diff_row.find( 'th' );
                // Add "has_diff" row class
                this_diff_row.addClass( 'has_diff' );
                this_th.addClass( 'diff' );
                curr_td.addClass( 'diff' );
            }
        });
        // Only show diff rows
        if ( bool ) {
            jQuery( '.cpl_table tr:not(:first-of-type):not(.image)' ).hide();
            jQuery( '.cpl_table tr:not(:first-of-type):not(.image).has_diff' ).show();
        }
    });
}

// Show all - Remove diff class
function cpl_all() {
    let cpl_diff_tds    = jQuery( '.cpl_table td.diff' );
    let this_th         = cpl_diff_tds.closest( 'tr' ).find( 'th' );
    // Remove diff classes / reset to default
    jQuery( '.cpl_table tr.has_diff' ).removeClass( 'has_diff' );
    jQuery( '.cpl_table tr' ).show();
    cpl_diff_tds.removeClass( 'diff' );
    this_th.removeClass( 'diff' );
}

// Get comparelist row heading information
function cpl_get_heading( item, bool, arg ) {
    let current_width = cpl_container.width();
    // Only get into this when the mobile breakpoint has been reached ...
    if ( current_width < 750 ) {
        // let cpl_info            = jQuery( '.cpl_info' );
        let cpl_info_heading    = cpl_info.find( '.heading' );
        let cpl_info_text       = cpl_info.find( ' .text' );
        let this_cell_text;
        // Found listing - Extract the li content and add a <br> tag after each except for the last one
        if ( item.find( 'ul li' ).length > 0 ) {
            // console.log( 'found ul li' );
            let li_content = '';
            item.find( 'ul li' ).each( function( index ) {
                // Add the li content
                li_content += jQuery( this ).html();
                // Add a <br> tag after each except for the last one
                if ( index < item.find( 'ul li' ).length - 1 ) {
                    li_content += ' &bull; ';
                }
            });
            // Replace the td content with the modified content
            this_cell_text = li_content;
            // Found an icon - Create a value based on its class
        } else if ( item.find( 'div[class*="icon"]' ).length > 0 ) {
            // console.log( 'div with icon' );
            if ( item.find( 'div[class*="yes"]' ).length > 0 ) {
                // console.log( 'YES ICON' );
                // Replace the td content with the modified content
                this_cell_text = 'YES';
            } else {
                // console.log( 'NO ICON' );
                // Replace the td content with the modified content
                this_cell_text = 'NO';
            }
            // Otherwise, just grab the text
        } else {
            this_cell_text = item.text().replace( /(<([^>]+)>)/ig, '' ).trim();
        }
        // Continue ...
        let this_th             = item.closest( 'tr:not(.image)' ).find( 'th' );
        let all_tds             = jQuery( '.cpl_table tr:not(.image) td' );
        let this_heading_text   = this_th.text().replace( /(<([^>]+)>)/ig, '' ).trim();
        // Remove some highlighting classes
        // all_tds.removeClass( 'current' );
        all_tds.removeClass( 'pulse' );
        // Dump text where it belongs, if needed ...
        if ( bool === true ) {
            // We found heading text, get heading data
            if ( this_heading_text.length ) {
                cpl_info.removeClass( 'no_heading' );
                cpl_info_heading.html( this_heading_text );
                // No text - add no heading class to the heading cell to remove the :after symbol
            } else {
                cpl_info_heading.html( '' );
                cpl_info.addClass( 'no_heading' );
            }
            // We found cell text, get the data
            if ( this_cell_text.length ) {
                cpl_info_text.html( this_cell_text );
                // No text, also here no :after symbol is needed
            } else {
                cpl_info.addClass( 'no_heading' );
                cpl_info_text.html( '' );
            }
            // Otherwise, just revert everything ...
        } else {
            // Reset text
            cpl_info_heading.html( '' );
            cpl_info.addClass( 'no_heading' );
            cpl_info_text.html( '' );
            item.removeClass( 'pulse' );

            return false;
        }
    }
}

// Highlight comparelist item column boolean
function cpl_highlight_toggle( bool ) {
    if ( bool ) {
        cpl_highlighting = true;
    } else {
        cpl_highlighting = false;
    }
}

// Highlight comparelist item column data
function cpl_highlight_column( item, bool ) {
    let this_tr                 = item.closest( 'tr' );
    let this_column_nr          = item.index();
    let this_row_th             = this_tr.find( 'th' )
    let this_row_td             = this_tr.find( 'td' );
    let this_column_siblings    = jQuery( '.cpl_body tr:not(.image)' ).find( 'td:nth-child(' + ( this_column_nr + 1 ) + ')' );
    // Do some highlighting, but only if it is allowed
    if ( cpl_highlighting === true && bool === true ) {
        this_row_th.addClass( 'highlight' );
        this_row_td.addClass( 'highlight' );
        this_column_siblings.addClass( 'highlight' );
        item.addClass( 'highlight' );
        item.addClass( 'current' );
    } else {
        this_row_th.removeClass( 'highlight' );
        this_row_td.removeClass( 'highlight' );
        this_column_siblings.removeClass( 'highlight' );
        item.removeClass( 'highlight' );
        item.removeClass( 'current' );
        return false;
    }
}

// Sort comparelist columns
function cpl_column_sort( e, bool ) {
    cpl_sorting = bool;
    if ( bool === true ) {
        cpl_tab.find( '.cpl_head' ).addClass( 'active' );
        let cpl_row = jQuery( '.cpl_body tr' );
        // Initiate UI magic ...
        jQuery( '.cpl_head tr' ).sortable({
            containment: 'parent',
            placeholder: 'placeholder',
            opacity: 0.5,
            helper: 'clone',
            cursor: 'move',
            axis: 'x',
            start: function( e, ui ) {
                let this_td = ui.item.index() - 1;
                cpl_row.each( function( index, el ) {
                    jQuery( 'td', el ).eq( this_td ).addClass( 'ui_sort' );
                });
            },
            beforeStop: function( e, ui ) {
                let that_td = ui.item.index() - 1;
                cpl_row.each( function( index, el) {
                    let this_cell = jQuery( '.ui_sort', el ).detach();
                    // Check if the dropped column is before the first cell
                    if ( that_td < 0 ) {
                        // If so, insert the column as the first cell
                        this_cell.prependTo( el );
                        // console.log( 'Dropped column placed before the first column.' );
                    }
                    // Check if the dropped column is within the table row
                    else if ( that_td >= 0 && that_td < jQuery( 'td', el ).length ) {
                        // If so, insert the column before the existing column
                        this_cell.insertBefore( jQuery( 'td', el ).eq( that_td ));
                        // console.log( 'Dropped column placed before an existing column.' );
                    }
                    // Check if the dropped column is after the last cell
                    else if ( that_td === jQuery( 'td', el ).length ) {
                        // If so, append the column as the last cell
                        this_cell.appendTo( el );
                        // console.log( 'Dropped column placed after the last column.' );
                    }
                    // Otherwise, the dropped column is after an existing column
                    else {
                        // Insert the column after the existing column
                        this_cell.insertAfter( jQuery( 'td', el ).eq( that_td ));
                        // console.log( 'Dropped column placed after an existing column.' );
                    }
                    // Remove temporary markup
                    this_cell.removeClass( 'ui_sort' );
                });
                // Get the new column sort order
                let this_tar = ui.item.closest( 'tr' ).find( 'td' );
                // Empty sort array before rebuilding
                cpl_sort_arr = [];
                // Rebuild sort array
                this_tar.each( function() {
                    let this_id = parseInt( jQuery( this ).attr( 'data-id' ));
                    cpl_sort_arr.push( this_id );
                });
                // Trigger AJAX function to send the new column sort order
                wait( 250 ).then( function() {
                    // Only push id's that are not empty
                    // TODO: Check if this causes issues on the actual sort order!
                    cpl_sort_arr = cpl_sort_arr.filter( item => item );
                    cpl_do_sort( cpl_sort_arr );
                });
            },
            // Specify that only td elements can be dragged and sorted
            items: '> td'
        }).disableSelection();
        // Fix th height for stubborn -webkit browsers
        cpl_th();
    } else {
        cpl_tab.find( '.cpl_head' ).removeClass( 'active' );
    }
}

// Separate AJAX function to send the new column sort order
// Update the comparelist session
function cpl_do_sort( sort_arr ) {
    // Some AJAX'ing
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_action: 'compare_products',
            array: sort_arr,
            function: 'sort'
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            // Empty sort array before rebuilding
            cpl_sort_arr = [];
        },
        complete: function( data ) {
            // Reload the list with latest data
            // do_cpl();
        },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

// Do comparelist
let do_cpl = function( arg, ref, slick ) {
    // Debug ...
    // console.log( 'Comparelist action: ' + arg );
    // Some vars
    let cpl_count   = jQuery( '.pagehead_container' ).find( '.cpl_count' );
    let action      = '';
    // Switch arguments
    switch ( arg ) {
        case 'load':
            action = 'load';
            cpl_ajax( ref, action );
            break;
        case 'add':
            if ( cpl_count.text() === '10' ) {
                toast_title = GLOB_ATTENTION;
                toast_icon  = 'error';
                toast_content = CPL_MAX_LIMIT_REACHED;
                do_toast(toast_title, toast_content, toast_icon, 6000, '', true);
                return false;
            } else {
                action = 'add_product';
                cpl_ajax( ref, action );
            }
            break;
        case 'remove':
            action = 'add_product';
            cpl_ajax( ref, action );
            break;
        case 'del':
            action = 'delete';
            if ( arg === 'del' ) {
                Swal.fire({
                    icon: 'warning',
                    title: GLOB_WARNING,
                    html: CPL_BTN_DEL_CONFIRM,
                    showDenyButton: true,
                    confirmButtonText: BTN_CONTINUE,
                    denyButtonText: BTN_CANCEL,
                    showCloseButton: true
                }).then((result) => {
                    if ( result.isConfirmed ) {
                        cpl_ajax( ref, action );
                    }
                })
            }
            break;
        default:
            if ( body_class( 'is_comparelist' ) ) {
                action = 'load';
            } else {
                action = 'count';
            }
            cpl_ajax( ref, action );
            break;
    }
}

let cpl_ajax = function( id, func ) {
    // Some vars
    let cpl_count   = jQuery( '.pagehead_container' ).find( '.cpl_count' );
    // let cpl_results = jQuery( '.cpl_table' );
    let cpl_button  = jQuery( '.comparelist_button[data-ref="' + id + '"]' );
    // Some AJAX'ing
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_action: 'compare_products',
            id: parseInt( id ),
            function: func
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            if ( data.reload_page !== 'undefined' && data.reload_page === true ) {
                location.reload();
            } else {
                // Debug ...
                // console.log( 'Comparelist data: ' + data );
                // console.log( 'Comparelist count: ' + data.product_count );
                // Inject results into wrapper ...
                // cpl_tab.html( data.html );
                cpl_wrapper.find( '.cpl_container.sticked .cpl_table' ).html( data.html_sticked );
                cpl_wrapper.find( '.cpl_container:not(.sticked) .cpl_table' ).html( data.html );

                // Update comparelist balloon counter ...
                cpl_count.html( data.product_count );
                // Set active class and display toast message
                toast_title = GLOB_SUCCESS;
                toast_icon = 'success';
                // Toggle
                if ( cpl_button.hasClass( 'active' ) ) {
                    if (id !== 'undefined' && id > 0 ) {
                        toast_content = CPL_REMOVED_SUCCESS;
                    }
                    cpl_button.attr( 'data-arg', 'add' );
                    cpl_button.removeClass( 'active' );
                    cpl_button.attr( 'data-tooltip', CPL_BTN_TOOLTIP_ADD);
                } else {
                    if ( id !== 'undefined' && id > 0 ) {
                        toast_content = CPL_ADDED_SUCCESS;
                    }
                    cpl_button.attr( 'data-arg', 'remove' );
                    cpl_button.addClass( 'active' );
                    cpl_button.attr( 'data-tooltip', CPL_BTN_TOOLTIP_REMOVE );
                }
                // Toast
                if ( id !== 'undefined' && id > 0 ) {
                    do_toast(toast_title, toast_content, toast_icon, 3000, '', true);
                }
            }
        },
        complete: function( data ) {
            debounce( cpl_size, 50 );
        },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}